import { useState } from 'react'
import { useIntl } from 'react-intl'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import ModalBase from 'LuxKit/Modal/ModalBase'
import SharedCartsCartSelectionModalContent from './SharedCartsCartSelectionModalContent'
import SharedCartsCreateSharedCartModalContent from './SharedCartsCreateSharedCartModalContent'
import { getCartMachineActor } from 'machines/cart/getCartMachineActor'
import { useSelector } from '@xstate/react'
import { selectItemsByActiveVisibleCart } from 'machines/cart/selectors'

type Props = {
  multiCartItemIdsToMove: Array<string>
}

function SharedCartsCartSelectionModal(props: Props) {
  const { multiCartItemIdsToMove } = props
  const intl = useIntl()
  const modalElement = useModalElementContext()
  const [step, setStep] = useState<'cartSelection' | 'createSharedCart'>('cartSelection')

  // This modal is getting opened from Snackbar which is out of context of MachineContextProvider.
  // hence we use getCartMachineActor() to get the actor ref else MultiCartContext.useActorRef() is preferred.
  const multiCartActorRef = getCartMachineActor()
  if (!multiCartActorRef) {
    throw new Error('Multi cart actor ref not found')
  }

  // find the cart items from given itemIds inside multiCartMachine context.
  const activeVisibleCartItems = useSelector(multiCartActorRef, selectItemsByActiveVisibleCart)
  const multiCartItems = Object.values(activeVisibleCartItems).filter(item => multiCartItemIdsToMove.includes(item.id))

  const onChangeStep = (step: 'cartSelection' | 'createSharedCart') => {
    setStep(step)
  }

  const onClose = () => {
    modalElement.resolve()
  }

  return (
    <ModalBase onClose={onClose}>
      {step === 'cartSelection' && <SharedCartsCartSelectionModalContent
        multiCartItemIdsToMove={multiCartItemIdsToMove}
        onClose={onClose}
        onCreateNewSharedCart={onChangeStep}
      />}
      {step === 'createSharedCart' && <SharedCartsCreateSharedCartModalContent
        title={intl.formatMessage({
          id: 'aB9JlkZggGbQQZHoh08d',
          defaultMessage: 'Create new shared cart',
        })}
        description={intl.formatMessage({
          id: 'dIQhEFjK-SodiDsg6r1e',
          defaultMessage: 'We’ll start a new shared cart where everyone you invite can add and edit items before booking.',
        })}
        multiCartItems={multiCartItems}
        onClose={onClose}
        onAfterSubmit={onClose}
        onBack={() => onChangeStep('cartSelection')}
      />}
    </ModalBase>
  )
}

export default SharedCartsCartSelectionModal
